import {
  Table,
  TableHead,
  TableBody,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default RulesTable;

function RulesTable(props) {
  const { rules, onEditRule, onDeleteRule } = props;

  if (rules.length === 0) return null;

  return (
    <Table>
      <TableHead>
        <TableHeader>Name</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {rules.map((rule, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>{rule.outputPort}</TableCell>
              <TableCell>
                <div className="flex items-center gap-x-2">
                  <Button
                    plain
                    onClick={() => onEditRule(rule, idx)}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    plain
                    onClick={() => onDeleteRule(idx)}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
